/* global Stimulus */

stimulusApp.register(
  "email-typo",
  class extends Stimulus.Controller {
    static targets = ["input", "error"]
    static values = { message: String }

    #suggestedEmail = null
    #checkTyposDebounced = null
    #lastCheckedEmail = null

    connect() {
      this.#checkTyposDebounced = HB.debounce(() => this.checkTypos(), 500)
    }

    disconnect() {
      this.#checkTyposDebounced.cancel()
    }

    checkTyposDebounced() {
      this.#checkTyposDebounced()
    }

    async checkTypos() {
      const email = this.inputTarget.value.trim()

      if (!email) {
        if (this.#suggestedEmail) this.clearError()
        return
      }

      // Re-show suggestion if it was cleared externally
      if (email === this.#lastCheckedEmail && this.#suggestedEmail) {
        this.#showSuggestion(this.#suggestedEmail)
        return
      }

      if (email === this.#lastCheckedEmail) return

      const locale = (document.documentElement.lang || "en").toLowerCase()
      const url = `/${locale}/email_typo_suggestion`

      let suggestion

      try {
        const response = await RailsRequest.get(url, {
          query: { email },
          responseKind: "json",
        })

        if (email !== this.inputTarget.value.trim()) return
        if (!response.ok) return

        const body = await response.json
        suggestion = body.suggestion
      } catch {
        // network error or bad response - leave email unchecked, retry on next check
        return
      }

      this.#lastCheckedEmail = email
      if (suggestion) {
        this.#showSuggestion(suggestion)
      } else if (this.#suggestedEmail) {
        this.clearError()
      }
    }

    clearError() {
      this.#lastCheckedEmail = null
      this.#suggestedEmail = null
      const container = this.inputTarget.closest(".field-container")
      container?.classList.remove("field-container_error")
      this.errorTarget.innerHTML = ""
      this.errorTarget.classList.add("hidden")
    }

    acceptSuggestion(event) {
      const target =
        event.target instanceof Element
          ? event.target.closest("[data-email-typo-suggestion]")
          : null
      if (!target || !this.#suggestedEmail) return
      event.preventDefault()
      this.inputTarget.value = this.#suggestedEmail
      this.clearError()
      this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
      this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }

    #showSuggestion(suggestedEmail) {
      this.#suggestedEmail = suggestedEmail

      const link = document.createElement("a")
      link.className = "no-underline"
      link.href = "#"
      link.dataset.emailTypoSuggestion = "true"
      link.textContent = suggestedEmail

      const [before, after] = this.messageValue.split("%{email}")

      const container = this.inputTarget.closest(".field-container")
      container?.classList.add("field-container_error")

      this.errorTarget.innerHTML = ""
      this.errorTarget.append(before, link, after ?? "")
      this.errorTarget.classList.remove("hidden")
    }
  },
)
